export default __webpack_public_path__ + "static/images/integrated-charts.7a6337fe.png";